export default __webpack_public_path__ + "static/media/stock-1.502461ac.png";